import axios from "axios";
import apiPaths from "app/utils/apiPaths";

function resolveApiBase() {
  const raw = window._env_?.REACT_APP_API_ENDPOINT || "http://localhost:9090/";
  return String(raw).endsWith("/") ? String(raw) : `${raw}/`;
}

function publicClient() {
  return axios.create({
    baseURL: resolveApiBase(),
    withCredentials: false,
  });
}

export async function fetchPublicTokenCatalog(host) {
  const res = await publicClient().get(apiPaths.HEALTH_CARE_PORTAL.PATIENT.PUBLIC_TOKEN.CATALOG, {
    params: { host },
  });
  return res.data;
}

export async function submitPublicTokenRegistration(host, payload) {
  const res = await publicClient().post(
    apiPaths.HEALTH_CARE_PORTAL.PATIENT.PUBLIC_TOKEN.REGISTER,
    payload,
    { params: { host } },
  );
  return res.data;
}

export function publicTokenErrorMessage(error) {
  const data = error?.response?.data;
  if (data && typeof data === "object" && data.message) return data.message;
  if (typeof data === "string" && data.trim()) return data;
  return "Unable to complete registration. Please try again.";
}
